export const SERIES_STORIES_PER_PAGE = 25;

export const TAB_SERIES_ORDER_BY_DESC_HASH = 'tab-order-by-desc';

export const TAB_SERIES_ORDER_BY_ASC_HASH = 'tab-order-by-asc';
